export { initMainPage } from "./mainPage";
export * as listView from "./listView";

export const initBuildingMap = (...args: Parameters<typeof import("./buildingMap").initBuildingMap>) =>
    import("./buildingMap").then(module => module.initBuildingMap(...args));

export const initColonyPedigree = (...args: Parameters<typeof import("./colonyPedigree").initColonyPedigree>) =>
    import("./colonyPedigree").then(module => module.initColonyPedigree(...args));

export const initDeviceCategoryList = (...args: Parameters<typeof import("./deviceCategoryList").initDeviceCategoryList>) =>
    import("./deviceCategoryList").then(module => module.initDeviceCategoryList(...args));

export const initDeviceEventCategoryList = (...args: Parameters<typeof import("./deviceEventCategoryList").initDeviceEventCategoryList>) =>
    import("./deviceEventCategoryList").then(module => module.initDeviceEventCategoryList(...args));

export const initDrugCategoryList = (...args: Parameters<typeof import("./drugCategoryList").initDrugCategoryList>) =>
    import("./drugCategoryList").then(module => module.initDrugCategoryList(...args));

export const initOrderRequestCatalogImport = (...args: Parameters<typeof import("./orderRequestCatalogImport").initOrderRequestCatalogImport>) =>
    import("./orderRequestCatalogImport").then(module => module.initOrderRequestCatalogImport(...args));

export const initOrderRequestCatalogItemList = (...args: Parameters<typeof import("./orderRequestCatalogItemList").initOrderRequestCatalogItemList>) =>
    import("./orderRequestCatalogItemList").then(module => module.initOrderRequestCatalogItemList(...args));

export const initOrderRequestCatalogList = (...args: Parameters<typeof import("./orderRequestCatalogList").initOrderRequestCatalogList>) =>
    import("./orderRequestCatalogList").then(module => module.initOrderRequestCatalogList(...args));

export const initPriceExternalOrderList = (...args: Parameters<typeof import("./priceExternalOrderList").initPriceExternalOrderList>) =>
    import("./priceExternalOrderList").then(module => module.initPriceExternalOrderList(...args));

export const initProjectCategoryList = (...args: Parameters<typeof import("./projectCategoryList").initProjectCategoryList>) =>
    import("./projectCategoryList").then(module => module.initProjectCategoryList(...args));

export const initPyratStatusReport = (...args: Parameters<typeof import("./pyratStatus/report").initPyratStatusReport>) =>
    import("./pyratStatus/report").then(module => module.initPyratStatusReport(...args));

export const initPyratStatusSettings = (...args: Parameters<typeof import("./pyratStatus/settings").initPyratStatusSettings>) =>
    import("./pyratStatus/settings").then(module => module.initPyratStatusSettings(...args));

export const initPyratStatusTrend = (...args: Parameters<typeof import("./pyratStatus/trend").initPyratStatusTrend>) =>
    import("./pyratStatus/trend").then(module => module.initPyratStatusTrend(...args));

export const initSacrificeMethodList = (...args: Parameters<typeof import("./sacrificeMethodList").initSacrificeMethodList>) =>
    import("./sacrificeMethodList").then(module => module.initSacrificeMethodList(...args));

export const initSacrificeReasonList = (...args: Parameters<typeof import("./sacrificeReasonList").initSacrificeReasonList>) =>
    import("./sacrificeReasonList").then(module => module.initSacrificeReasonList(...args));

export const initUserCertificateTypeList = (...args: Parameters<typeof import("./userCertificateTypeList").initUserCertificateTypeList>) =>
    import("./userCertificateTypeList").then(module => module.initUserCertificateTypeList(...args));

export const initColorRules = (...args: Parameters<typeof import("./colorRules").initColorRules>) =>
    import("./colorRules").then(module => module.initColorRules(...args));
